<template>
	<div class="template date" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span> </label>
			<input class="input_value" v-model="dataVal.Value" type="date" :placeholder="dataVal.Placeholder" :min="dataVal.MinDate" />
		</div>
		
	</div>
</template>

<script>
	export default{
		props: ['dataVal'],
		data(){
			return{
				
			}
		}
		
	}
</script>

<style scoped lang="less">
	@import '../../assets/css/common.css';
</style>
